import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c430a3ca"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "px-6" }

import { useI18n } from 'vue-i18n'

import Modal from '@/popup/components/shared/Modal/Modal'
import { PermissionLevels } from '@/shared/Permissions'
import AccountWizard from '@/popup/components/shared/Wizard.vue'
import SvgIcon from '@/popup/components/shared/SvgIcon.vue'
import PermissionsBlock from '@/popup/components/shared/ControllerPermissions/PermissionsBlock.vue'

type Emits = {
  (event: 'on-close'): void
  (event: 'on-close-interactions'): void
  (event: 'on-change-permission', permission: string, isChecked: boolean): void
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ShowControllerInteractionsPermissions',
  props: {
    readOnlyMode: { type: Boolean },
    controllerName: {},
    permissionLevels: {}
  },
  emits: ["on-close", "on-close-interactions", "on-change-permission"],
  setup(__props: any, { emit: __emit }) {

const { t: $t } = useI18n()



const emits = __emit

const onCloseInteractions = () => {
  emits('on-close-interactions')
}

const changePermission = (permission: string, isChecked: boolean) => {
  emits('on-change-permission', permission, isChecked)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Modal).Wrapper, {
    class: "wrapper full-page",
    "data-testid": "modal-info"
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(Modal).Background, { class: "darker blurry" }),
      _createVNode(_unref(Modal).Content, {
        class: "full-page",
        scrollable: false
      }, {
        default: _withCtx(() => [
          _createVNode(AccountWizard, {
            title: _unref($t)('app_detail.permissions.interactions_settings_sub'),
            progress: 0
          }, {
            default: _withCtx(() => [
              _createVNode(SvgIcon, {
                onClick: onCloseInteractions,
                name: "arrow-left-lg",
                height: "24",
                width: "24",
                class: "is-clickable"
              })
            ]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["title"]),
          _createElementVNode("div", _hoisted_1, [
            _createVNode(PermissionsBlock, {
              "margin-classes": ['p-4'],
              disabled: _ctx.readOnlyMode,
              onOnChange: changePermission,
              control: _ctx.controllerName,
              icon: "permission-profiledata-auth",
              "action-icon": "sign",
              color: "var(--blue-75)",
              permissions: _ctx.permissionLevels
            }, null, 8 /* PROPS */, ["disabled", "control", "permissions"])
          ])
        ]),
        _: 1 /* STABLE */
      })
    ]),
    _: 1 /* STABLE */
  }))
}
}

})